/* @flow */
import { observable, action, toJS } from 'mobx';

import { ApiModel } from 'api/ApiModel';

export default class LocationChooseStore extends ApiModel {
  @observable companies = [];

  @observable sites = [];

  @observable building = [];

  @observable room = [];

  @observable countries = [];

  @observable companyId = '';

  getLocationURL: Function = (companyId: string, siteId: string, countryId: string) => {
    return `locations/${companyId}/${countryId}?parent_id=${siteId}`;
  };

  @action async loadProjectCompanies(accountId: string): Promise<void> {
    this.companies = await this.api
      .getResource(`accounts/${accountId}/companies`)
      .catch((err: string) => {
        console.log(err);
      });
  }

  companyModel = (): Promise<*> => {
    return new Promise((resolve: Function) => {
      resolve(toJS(this.companies.active));
    });
  };

  @action async loadProjectSites(companyId: string): Promise<void> {
    this.sites = await this.api
      .getResource(`companies/${companyId}/locations`)
      .catch((err: string) => {
        console.log(err);
      });

    this.loadProjectCountries(companyId);
    this.companyId = companyId;
  }

  siteModel = (search: string = '', selected: ?string | ?number): Promise<*> => {
    if (!selected) {
      return Promise.resolve([]);
    }

    return new Promise((resolve: Function) => {
      resolve(toJS(this.sites.active));
    });
  };

  @action async loadProjectBuilding(
    companyId: string,
    siteId: string,
    countryId: string
  ): Promise<void> {
    const url: string = this.getLocationURL(companyId, siteId, countryId);

    this.building = await this.api.getResource(url).catch((err: string) => {
      console.log(err);
    });
  }

  buildingModel = (search: string = '', selected: ?string | ?number): Promise<*> => {
    if (!selected) {
      return Promise.resolve([]);
    }

    return new Promise((resolve: Function) => {
      resolve(toJS(this.building.active));
    });
  };

  @action async loadProjectRooms(
    companyId: string,
    siteId: string,
    countryId: string
  ): Promise<void> {
    const url: string = this.getLocationURL(companyId, siteId, countryId);

    this.room = await this.api.getResource(url).catch((err: string) => {
      console.log(err);
    });
  }

  roomModel = (search: string = '', selected: ?string | ?number): Promise<*> => {
    if (!selected) {
      return Promise.resolve([]);
    }

    return new Promise((resolve: Function) => {
      resolve(toJS(this.room.active));
    });
  };

  @action async loadProjectSystems(
    companyId: string,
    siteId: string,
    countryId: string
  ): Promise<void> {
    const url: string = this.getLocationURL(companyId, siteId, countryId);

    this.system = await this.api.getResource(url).catch((err: string) => {
      console.log(err);
    });
  }

  systemModel = (search: string = '', selected: ?string | ?number): Promise<*> => {
    if (!selected) {
      return Promise.resolve([]);
    }

    return new Promise((resolve: Function) => {
      resolve(toJS(this.system.active));
    });
  };

  @action async loadProjectCountries(companyId: string): Promise<void> {
    const url: string = `companies/${companyId}/countries`;

    this.countries = await this.api.getResource(url).catch((err: string) => {
      console.log(err);
    });
  }

  countriesModel = (search: string = '', selected: ?string | ?number): Promise<*> => {
    if (this.companyId === '') {
      return Promise.resolve([]);
    }

    return new Promise((resolve: Function) => {
      resolve(toJS(this.countries));
    });
  };
}

export type TypeLocationChooserStore = {
  companies: [],
  sites: [],
  location: [],
  countries: [],
  loadProjectCompanies: (accountId: string) => {},
  companyModel: () => {},
  loadProjectSites: (companyId: string) => {},
  siteModel: () => {},
  loadProjectBuilding: (companyId: string, siteId: string, countryId: string) => {},
  buildingModel: () => {},
  loadProjectRooms: (companyId: string, siteId: string, countryId: string) => {},
  roomModel: () => {},
  loadProjectSystems: (companyId: string, siteId: string, countryId: string) => {},
  systemModel: () => {},
  loadProjectCountries: (companyId: string) => {},
  countriesModel: () => {},
};
